<template>
  <div class="n-radio">
    <div
      v-for="option in options"
      :class="`radio-wrapper`"
      :key="option.value"
    >
      <input
        :id="`${ id }-${ option.value }`"
        :type="`radio`"
        :class="`radio`"
        :name="`n-radio-${ id }`"
        :value="option.value"
        :checked="option.value === value"
        :readonly="readonly"
        @change="$emit('input', option.value)"
      >

      <label :for="`${ id }-${ option.value }`" v-html="option.text" />
    </div>

    <div v-if="error" class="hint-wrapper">
      <div class="hint error open">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'n-radio',

	props: {
		value: {
      default: ''
		},

		id: {
			type: String,
			default: ''
		},

    options: {
			type: Array,
			default: () => []
		},

    readonly: {
			type: Boolean,
			default: false
    },

    error: {
			type: String,
			default: ''
		}
	}
};
</script>

<style lang="scss">
.n-radio {
  display: flex;
  flex-wrap: wrap;

  input[type="radio"] + label:before {
    top: calc(50% - 15px);
  }

  .hint-wrapper {
    flex: 1 1 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/n-radio.vue